import { Field, ObjectType } from '@nestjs/graphql'
import { InvoiceDto } from './invoice.dto'

@ObjectType()
export class InvoicesPageDto {
  @Field(t => [InvoiceDto])
  invoices!: InvoiceDto[]

  @Field()
  hasMore!: boolean

  @Field({ nullable: true })
  nextStartingAfter?: string
}
